import React from 'react'
import HospitalHome from 'presentation/hospital/pages/Home'

export default function makeHospitalSurgicalHome() {
  return <HospitalHome />
}
